import React from 'react'
import NavBarItem from '../components/NavBarItem'
import { connect } from 'react-redux'
import { setFileName } from '../actions'
import { loadActions, loadSettings, loadPresetSettings } from '../actions'
import Immutable from 'immutable'
import { tooltips } from "../constants"
import jsonpack from 'jsonpack'
import commands from '../json/commands.json'

function openFile() {
    console.log("open file triggered")
    document.getElementById('openDocument').click()
}


function fileUploaded(e, dispatch) {

    console.log("attemping file upload", e.target.files[0])
    if (typeof (e.target.files[0]) !== 'undefined') {
        dispatch(setFileName(e.target.files[0].name.split('.')[0]))
        var reader = new FileReader();
        reader.onload = function () {
            var json = jsonpack.unpack(reader.result)
            console.log(json);
            for (const [key, preset] of Object.entries(json.actions)) {
                for (const [key, button] of Object.entries(preset)) {
                    for (const [key, command] of Object.entries(button)) {
                        if (command.options != null) {
                            for (const [key, option] of Object.entries(command.options)) {
                                if (key == "Command if looper playing") {
                                    for (const [key, value] of Object.entries(option.range.options)) {
                                        if (value == option.value) {
                                            option.value = commands['Ableton Commands']['Looper Control'].options['Command if looper playing'].range.options[key]
                                            option.range.options = commands['Ableton Commands']['Looper Control'].options['Command if looper playing'].range.options
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (json.actions.clipboard) {
                delete json.actions.clipboard
            }
            dispatch(loadActions(json.actions))
            dispatch(loadSettings(Immutable.fromJS(json.settings)))
            if (json.presetSettings) {
                dispatch(loadPresetSettings(Immutable.fromJS(json.presetSettings)))
            }
        };
        reader.readAsText(e.target.files[0]);
    }
    e.target.value = null
}
const OpenDocument = ({ name, dispatch, icon }) => {
    return ( <
        >
        <
            input id="openDocument"
            accept=".dlcfg"
            onChange={
                (e) => fileUploaded(e, dispatch)
            }
            type="file"
            style={
                { display: "none" }
            }
        /> <
            NavBarItem tooltip={tooltips.OpenDocument}
            name={name}
            onClick={
                () => openFile()
            }
            icon={icon}
        /> < />
        )
}

        export default connect()(OpenDocument)